import React from 'react'
import cx from 'classnames'
import ArrowForward from '@mui/icons-material/ArrowForward'
import ArrowBack from '@mui/icons-material/ArrowBack'

const ArrowLink = ({ text, backArrow = false, url, textCx, tileHover = false, cxNames = '' }) => {
  const defaultCx = 'color-inherit decoration-inherit'

  return (
    <div className={cx('arrow w-max-content pointer', cxNames, { 'arrow-link': !tileHover })}>
      <a href={url} className={cx('dib f7 flex items-center ', defaultCx, textCx)}>
        {backArrow && <ArrowBack className={cx('vm mr3', defaultCx)} />}
        <span>{text}</span>
        {!backArrow && <ArrowForward className={cx('vm ml3', defaultCx)} />}
      </a>
    </div>
  )
}

export default ArrowLink
